/* Mobile-only PDP layout tweak: move the wishlist/compare buttons up next
   to the title (their normal position, deep inside the product form's
   button row, is hidden on mobile along with Add to Cart/Buy Now since the
   sticky bar covers those). Desktop untouched - this never runs there.
   See sections/main-product.liquid ('title' block, target anchor) and
   snippets/product-form.liquid (data-wiscp-source wrapper). */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');
  var source = document.querySelector('[data-wiscp-source]');
  var target = document.querySelector('[data-wiscp-mobile-target]');
  if (!source || !target) return;

  var originalParent = source.parentNode;
  var originalNextSibling = source.nextSibling;
  var moved = false;

  function apply(matches) {
    if (matches && !moved) {
      target.appendChild(source);
      moved = true;
    } else if (!matches && moved) {
      if (originalNextSibling) {
        originalParent.insertBefore(source, originalNextSibling);
      } else {
        originalParent.appendChild(source);
      }
      moved = false;
    }
  }

  apply(mq.matches);
  mq.addEventListener('change', function (e) { apply(e.matches); });
})();
